module.exports = __webpack_public_path__ + "img/WZ.2374de1d.png";